// /src/directives/wrapM2.js

const M2_REGEX = /(M²|M2|m²|m2)/g;

function wrapM2(textNode) {
  // Reiniciar el índice del regex global
  M2_REGEX.lastIndex = 0;

  const value = textNode.nodeValue;

  // Si no hay nada que reemplazar, salir
  if (!M2_REGEX.test(value)) return;

  // Reiniciar de nuevo después del test para seguridad
  M2_REGEX.lastIndex = 0;

  const parent = textNode.parentNode;
  if (!parent) return;

  const html = value.replace(M2_REGEX, match => {
    return `<span class="m2-lower">${match.toLowerCase()}</span>`;
  });

  const temp = document.createElement("span");
  temp.innerHTML = html;

  const fragment = document.createDocumentFragment();
  while (temp.firstChild) fragment.appendChild(temp.firstChild);

  parent.replaceChild(fragment, textNode);
}

function processNode(el) {
  if (!el) return;

  if (el.nodeType === Node.TEXT_NODE) {
    wrapM2(el);
    return;
  }

  const walker = document.createTreeWalker(
    el,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );

  let node;
  while ((node = walker.nextNode())) {
    wrapM2(node);
  }
}

export default {
  inserted(el) {
    processNode(el);
  },
  componentUpdated(el) {
    processNode(el);
  }
};
